<template>
  <v-card class="pa-2">
    <v-toolbar dense flat style="border-radius: 5px" class="mb-2">
      <v-toolbar-title class="body-2 beez-bold ">
        Metrics and Trends
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-layout row wrap>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex d-flex xs12>
            <v-card :class="kpiClass">
              <v-flex>
                <v-layout row wrap justify-space-between>
                  <v-flex xs12 class="align-center">
                    <v-flex style="border-radius: 10px;">
                      <v-layout class="row wrap">
                        <v-flex xs12 sm6 md4 lg2 class="pa-1">
                          <kpi-card
                            :heading="raisedCount"
                            sub-heading="Requests raised"
                            size="50"
                          >
                            <template slot="heading" slot-scope="slotProps">
                              <div class="display-3 font-weight-thin">
                                {{ slotProps.heading }}
                              </div>
                            </template>
                          </kpi-card>
                        </v-flex>
                        <v-flex xs12 sm6 md4 lg2 class="pa-1">
                          <kpi-card
                            :heading="completedCount"
                            sub-heading="Requests completed"
                            size="50"
                          >
                            <template slot="heading" slot-scope="slotProps">
                              <div class="display-3 font-weight-thin">
                                {{ slotProps.heading }}
                              </div>
                            </template>
                          </kpi-card>
                        </v-flex>
                        <v-flex xs12 sm6 md4 lg2 class="pa-1">
                          <kpi-card
                            :heading="pendingCount"
                            sub-heading="Request pending"
                            size="50"
                          >
                            <template slot="heading" slot-scope="slotProps">
                              <div class="display-3 font-weight-thin">
                                {{ slotProps.heading }}
                              </div>
                            </template>
                          </kpi-card>
                        </v-flex>
                        <v-flex xs12 sm6 md4 lg2 class="pa-1">
                          <kpi-card
                            :heading="failedCount"
                            sub-heading="Request failed"
                            size="50"
                          >
                            <template slot="heading" slot-scope="slotProps">
                              <div class="display-3 font-weight-thin">
                                {{ slotProps.heading }}
                              </div>
                            </template>
                          </kpi-card>
                        </v-flex>
                        <v-flex xs12 sm6 md4 lg2 class="pa-1">
                          <kpi-card
                            :heading="totalAssignedTasks"
                            sub-heading="Tasks assigned"
                            size="50"
                            :to="{ name: 'tasks' }"
                          >
                            <template slot="heading" slot-scope="slotProps">
                              <div class="display-3 font-weight-thin">
                                {{ slotProps.heading }}
                              </div>
                            </template>
                          </kpi-card>
                        </v-flex>
                        <v-flex xs12 sm6 md4 lg2 class="pa-1">
                          <kpi-card
                            :heading="totalGroupTasks"
                            sub-heading="Group tasks"
                            size="50"
                            :to="{ name: 'tasks' }"
                          >
                            <template slot="heading" slot-scope="slotProps">
                              <div class="display-3 font-weight-thin">
                                {{ slotProps.heading }}
                              </div>
                            </template>
                          </kpi-card>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row wrap class="pt-2">
      <self-service />
    </v-layout>
  </v-card>
</template>

<script>
import SelfService from '@/components/self-service/SelfService'
import KpiCard from '@/components/common/KpiCard'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'Home',
  components: { SelfService, KpiCard },
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      totalAssignedTasks: state => state.tasks.totalAssignedTasks,
      totalGroupTasks: state => state.tasks.totalGroupTasks,
      totalOwnTasks: state => state.tasks.totalOwnTasks,
      selfServices: state =>
        state.selfServices.selfServices.filter(item => item.active === true),
      selfServiceMetrics: state => state.selfServices.selfServiceMetrics,
      automationRequestCount: state =>
        state.automationRequests.automationRequestCountOnly,
      executionCount: state => state.execution.executionCount
    }),
    ...mapGetters({
      can: 'can'
    }),
    kpiClass() {
      return 'metric--card-0'
    },
    sparkline() {
      let spark = this.automationRequestCount.map(e => e.cnt)
      if (spark.length === 1) {
        spark.unshift(0, 0)
        return spark
      } else if (spark.length === 0) {
        return [0, 0]
      } else if (!_.isArray(spark)) {
        return [0].push(spark)
      } else {
        return spark
      }
    },
    count() {
      let countVar = 0
      this.automationRequestCount.forEach(e => {
        countVar = countVar + e.cnt
      })
      return countVar
    },
    executionSparkline() {
      let spark = this.executionCount.map(e => e.cnt)
      if (spark.length === 1) {
        spark.unshift(0, 0)
        return spark
      } else if (spark.length === 0) {
        return [0, 0]
      } else if (!_.isArray(spark)) {
        return [0].push(spark)
      } else {
        return spark
      }
    },
    totalExecutionCount() {
      let countVar = 0
      this.executionCount.forEach(e => {
        countVar = countVar + e.cnt
      })
      return (countVar / 60).toFixed(2)
    },
    gradient() {
      return [this.$vuetify.theme.secondary, this.$vuetify.theme.accent]
    },
    raisedCount() {
      try {
        return this.selfServiceMetrics.totalRequestRaised || 0
      } catch (e) {
        return 0
      }
    },
    completedCount() {
      try {
        return this.selfServiceMetrics.totalRequestCompleted || 0
      } catch (e) {
        return 0
      }
    },
    pendingCount() {
      try {
        return this.selfServiceMetrics.totalRequestPending || 0
      } catch (e) {
        return 0
      }
    },
    failedCount() {
      try {
        return this.selfServiceMetrics.totalRequestFailed || 0
      } catch (e) {
        return 0
      }
    }
  },
  created() {
    this.refresh()
  },
  watch: {
    showSparkline() {
      this.getSparklineData()
    }
  },
  methods: {
    getSparklineData() {
      try {
        if (this.showSparkline) {
          this.$store.dispatch('fetchAutomationRequestCountOnly')
        }
      } catch (e) {
        this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Automation request count',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      try {
        if (this.showSparkline) {
          this.$store.dispatch('fetchExecutionCount')
        }
      } catch (e) {
        this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch executions request count',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
    },
    refresh() {
      this.getSparklineData()
      this.$store.dispatch('fetchSelfServiceMetrics')
      this.$store.dispatch('fetchClaimedTasks', 'page=0&size=1')
      this.$store.dispatch('fetchUnClaimedTasks', 'page=0&size=1')
      this.$store.dispatch('fetchTotalOwnTaskCount')
    }
  }
}
</script>

<style scoped>
.metric--card-0 {
  /*background-image: radial-gradient(#303030 10%, #757575 100%);*/
  box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.08);
  border-radius: 10px;
}

.metric--card-1 {
  background-image: linear-gradient(135deg, #36d1dc 10%, #5b86e5 100%);
  box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.08);
  border-radius: 5px;
}
</style>
